import { Trans } from '@lyearn/i18n';

import fieldValidate from '../../helper/fieldValidate';
import {
  Field,
  FieldType,
  FieldValidationFunction,
  FieldValidationTypes,
  FormEmailField,
} from '../../types';
import { FieldInputType } from '../types';
import Input from './Input';

const fieldValidation: FieldValidationFunction<string> = {
  [FieldValidationTypes.Required]: ({ value, validation }) => {
    if (!value) {
      return validation?.message || <Trans i18nKey="Form:FieldRequiredMessage" />;
    }
  },
  [FieldValidationTypes.Custom]: () => undefined,
};

const PasswordInputField: FieldInputType<FormEmailField, string> = {
  Input,
  type: FieldType.Password,
  validate: (field, value, values) => {
    return fieldValidate({ field, value, values, fieldValidation });
  },
};

export default PasswordInputField;
